// extracted by mini-css-extract-plugin
export default {"pagelayout":"PageLayout_pagelayout__JpyOr"};